import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

const BriefScore = () => {
  const [selectedFirst, setSelectedFirst] = useState('');
  const [selectedWon, setSelectedWon] = useState('');
  const [applyWS, setApplyWS] = useState(false);
  const [selectedMom, setSelectedMom] = useState('');
  const [highlights, setHighlights] = useState('');

  
  const handleSaveButtonClick = () => {
    // Remove error classes
    const errorFields = document.querySelectorAll('.has-error');
    errorFields.forEach((field) => field.classList.remove('has-error'));

    const j = score.TeamId[0];
    let l = selectedFirst;
    if (l === 'Select') {
      l = score.TeamId[1];
    }
    const WSApplied = applyWS ? 1 : 0;

    if (!scorecheck(l, j, WSApplied)) return false;

    const lpen = parseInt(document.getElementById('txtPenalty' + l).value || 0);
    const jpen = parseInt(document.getElementById('txtPenalty' + j).value || 0);
    const jo = document.getElementById('txtWicket' + j).value === '10' ? tourover : parseFloat(document.getElementById('txtOver' + j).value || "0") + jpen;
    const lo = document.getElementById('txtWicket' + l).value === '10' ? tourover : parseFloat(document.getElementById('txtOver' + l).value || "0") + lpen;
    const mWonTxt = document.querySelector('option:selected', "#drpMWon").getAttribute('txt');
    const drrCalcData = {
      t1: {
        id: l,
        sc: document.getElementById('txtScore' + l).value || 0,
        ov: lo,
        pen: lo === tourover ? 0 : lpen
      },
      t2: {
        id: j,
        sc: document.getElementById('txtScore' + j).value || 0,
        ov: jo,
        pen: jo === tourover ? 0 : jpen
      },
      winner: 0,
      forfeit: 0
    };

    if (score.BriefMatch.length !== 0 || briefscoreflag === true) {
      let hStr = `data=MatchId_l=${document.getElementById('drpMatch').value},BatTeamId1_l=${l},BatTeamId2_l=${j},Team1Score_Inn1=${document.getElementById('txtScore' + l).value || 0},Team2Score_Inn1=${document.getElementById('txtScore' + j).value || 0},Team1Over_Inn1='${lo}',Team2Over_Inn1='${jo}',DispTeam1Over='${document.getElementById('txtOver' + l).value || 0}',DispTeam2Over='${document.getElementById('txtOver' + j).value || 0}',Team1Wicket_Inn1=${document.getElementById('txtWicket' + l).value || 0},Team2Wicket_Inn1=${document.getElementById('txtWicket' + j).value || 0},TossWon=${selectedWon},Highlights='${highlights}',WSApplied=${WSApplied},`;

      // Match tied
      if (mWonTxt === '2') {
        hStr += "Winner=3,";
        drrCalcData.winner = 3;
      }
      // Match abandoned
      else if (mWonTxt === '3') {
        hStr += "Winner=4,";
        drrCalcData.winner = 4;
      }
      // Match forfeited
      else if (mWonTxt === '4') {
        if (selectedWon === l) {
          hStr += "Winner=1,";
          drrCalcData.winner = 1;
        } else {
          hStr += "Winner=2,";
          drrCalcData.winner = 2;
        }
        hStr += "ForfitedTeam=" + selectedWon + ",";
        drrCalcData.forfeit = selectedWon;
      }
      // Team 1 won
      else if (selectedWon === selectedFirst) {
        hStr += "Winner=2,";
        drrCalcData.winner = 2;
      }
      // Team 2 won
      else {
        hStr += "Winner=1,";
        drrCalcData.winner = 1;
      }
      const drrPoints = calculatePointsAndDRR(drrCalcData, WSApplied);
      const drrT1 = drrPoints.team1, drrT2 = drrPoints.team2;

      hStr += `Mom=${selectedMom === 'Select' ? 'NULL' : selectedMom},TotalOvers=${tourover},Team1_drr=${drrT1.drr},Team2_drr=${drrT2.drr},Team1_Bonus=${drrT1.bonus},Team2_Bonus=${drrT2.bonus},Team1_Total=${drrT1.points},Team2_Total=${drrT2.points}`;

      // Penalty
      hStr += `,Team1Pently=${lpen},Team2Pently=${jpen}`;

      hStr += `&tablename=matches_details&field=MatchId_l&values=${document.getElementById('drpMatch').value}`;
      const webMethod1 = `${server}/updatescore`;
      fetch(webMethod1 + '?' + hStr)
        .then((response) => response.json())
        .then((data) => {
          if (data.Status === "success") {
            showSucMsg("Brief score has been updated.", "");
            MWonflag = false;
            document.getElementById('btnBPublish').disabled = false;
            $('#divbtn').style.display = 'block';
          } else {
            document.getElementById('btnBPublish').disabled = false;
            showErrMsg("There was an error saving the brief score.", "");
          }
        })
        .catch((error) => {
          document.getElementById('btnBPublish').disabled = false;
          showErrMsg("There was an error saving the brief score.", "");
        });
    } else {
      let hStr = `data=(${$('#drpMatch').value},${l},${j},${document.getElementById('txtScore' + l).value || 0},${document.getElementById('txtScore' + j).value || 0},${lo},${jo},${document.getElementById('txtOver' + l).value || 0},${document.getElementById('txtOver' + j).value || 0},${document.getElementById('txtWicket' + l).value || 0},${document.getElementById('txtWicket' + j).value || 0},`;

      // Tie
      if (mWonTxt === '2') {
        hStr += `3,NULL,${selectedMom || 'NULL'},${selectedWon || 'NULL'},'${highlights}',`;
      }
      // Abandoned
      else if (mWonTxt === '3') {
        hStr += `4,NULL,NULL,NULL,'${highlights}',`;
        drrCalcData.winner = 4;
      }
      // Forfeit
      else if (mWonTxt === '4') {
        if (selectedWon === l) {
          hStr += '1,';
          drrCalcData.winner = 1;
        } else {
          hStr += '2,';
          drrCalcData.winner = 2;
        }
        hStr += `${selectedWon},NULL,NULL,'',`;
        drrCalcData.forfeit = selectedWon;
      }
      // Team 1 won
      else if (selectedWon === selectedFirst) {
        hStr += `2,NULL,${selectedMom || 'NULL'},${selectedWon || 'NULL'},'${highlights}',`;
        drrCalcData.winner = 2;
      }
      // Team 2 won
      else {
        hStr += `1,NULL,${selectedMom || 'NULL'},${selectedWon || 'NULL'},'${highlights}',`;
        drrCalcData.winner = 1;
      }
      // Weighted score and Penalty
      hStr += `${WSApplied},${lpen},${jpen},`;

      const drrPoints = calculatePointsAndDRR(drrCalcData, WSApplied);
      const drrT1 = drrPoints.team1, drrT2 = drrPoints.team2;

      hStr += `${drrT1.drr},${drrT2.drr},${drrT1.bonus},${drrT2.bonus},${drrT1.points},${drrT2.points},${tourover})`;

      hStr += `&tablename=matches_details&field=(MatchId_l,BatTeamId1_l,BatTeamId2_l,Team1Score_Inn1,Team2Score_Inn1,Team1Over_Inn1,Team2Over_Inn1,DispTeam1Over,DispTeam2Over,` +
        `Team1Wicket_Inn1,Team2Wicket_Inn1,Winner,ForfitedTeam,Mom,TossWon,Highlights,WSApplied,Team1Pently,Team2Pently,Team1_drr,Team2_drr,Team1_Bonus,Team2_Bonus,Team1_Total,Team2_Total,TotalOvers)`;

      const webMethod1 = `${server}/savescore`;
      fetch(webMethod1 + '?' + hStr)
        .then((response) => response.json())
        .then((data) => {
          if (data.Status === "success") {
            enable_disable_div('divM', 'disable');
            $('#divbtn').style.display = 'block';
            showSucMsg("Brief score has been saved.", "");
            briefscoreflag = true;
            document.getElementById('btnBPublish').disabled = false;
            $.uniform.update();
          } else {
            briefscoreflag = false;
            showErrMsg("There was an error saving the brief score.", "");
          }
        })
        .catch((error) => {
          briefscoreflag = false;
          showErrMsg("There was an error saving the brief score.", "");
        });
    }
  };

  return (
    <div id='main'>
      {/* include header */}
      <div id='main-content'>
        <div id="content" className="bordered">
          <div id='page-data'>
            <div id='scorecard'>
              <span className="drpMatch">
                <div style={{ marginBottom: '10px' }} className="input-fields-400px">
                  Match: <select id="drpMatch" name="select-match" style={{ opacity: 0 }}></select>
                </div>
              </span>
              <div id="scorecard-form">
                <div className='sub-section'>
                  <h4>Match Details</h4>
                  <table id='tblSch' className="match-info">
                    <tbody></tbody>
                  </table>
                </div>
              </div>

              <div id="briefscoresection" className="displayNo">
                <div className='sub-section'>
                  <h4>Brief Score</h4>
                  <div>
                    <div style={{ paddingTop: '10px' }}>
                      <div className="form-brief-field-one">Result: </div>
                      <div className="form-brief-field-two">
                        <Form.Select id='drpMWon' txt='Match Won Team'>
                          <option>Select</option>
                        </Form.Select>
                      </div>
                    </div>
                    <div style={{ paddingTop: '10px' }}>
                      <Form.Check type="checkbox" id="apply-ws" name="apply-ws" className="apply-ws" label="Apply Weighted Score *" onChange={(e) => setApplyWS(e.target.checked)} />
                      <div style={{ margin: '5px 0', color: '#888', fontWeight: 200 }}>
                        * Use only if the match couldn't be completed and Weighted Score was applied. Applicable only if both teams played at least 10 overs.
                      </div>
                    </div>
                    <br />
                    <div className='form-brief-col-two'>
                      <div className='form-brief-field-one'>Toss Won By: </div>
                      <div className='form-brief-field-two'>
                        <Form.Select id='drpWon' value={selectedWon} onChange={(e) => setSelectedWon(e.target.value)}></Form.Select>
                      </div>
                    </div>
                    <div className='form-brief-col-one'>
                      <div className='form-brief-field-one'>Batting First: </div>
                      <div className='form-brief-field-two'>
                        <Form.Select id='drpFirst' value={selectedFirst} onChange={(e) => setSelectedFirst(e.target.value)}></Form.Select>
                      </div>
                    </div>
                    <div className="form-brief-col-two">
                      <div className="form-brief-field-one">Overs: </div>
                      <div className="form-brief-field-two">
                        <Form.Control type="text" size="3" id="txtTourOvers" onKeyPress={event => isNumberKey(event)} name="TournamentOvers" className="text" />
                      </div>
                    </div>
                    <div className='grey-box'>
                      <div className='form-section-col-one'>
                        <h3>
                          Score : <div style={{ display: 'inline-block' }} id="first-inning-team">--</div>
                        </h3>
                        <div className='form-section-field-one'>Run Scored: </div>
                        <div className='form-section-field-two'>
                          <Form.Control type="text" size="3" id="first-inning-runs" onKeyPress={event => isNumberKey(event)} name="first_inning_runs" className="text" />
                        </div>
                        <div className='form-section-field-one'>Wickets: </div>
                        <div className='form-section-field-two'>
                          <Form.Control type="text" size="3" id="first-inning-wickets" onKeyPress={event => isNumberKey(event)} name="first_inning_wickets" className="text" />
                        </div>
                        <div className='form-section-field-one'>Overs: </div>
                        <div className='form-section-field-two'>
                          <Form.Control type="text" size="3" id="first-inning-overs" onKeyPress={event => isfloatKey(event)} name="first_inning_overs" className="text" />
                        </div>
                        <div className='form-section-field-one'>Penalty Enf. </div>
                        <div className='form-section-field-two'>
                          <Form.Check type="checkbox" id="first-inning-penalty-enf" style={{ opacity: 0 }} name="first_inning_penalty_enf" viewdiv="first-inning-penaltydiv" className="penalitychk" label={<img src="images/info-icon.png" id="penalty_info_img" className="penalty_info" />} />
                        </div>
                        <div id="first-inning-penaltydiv" style={{ display: 'none', paddingTop: '3px' }}>
                          <div className='form-section-field-one'>Penalty Overs: </div>
                          <div className='form-section-field-two'>
                            <Form.Control type="text" size="2" id="first-inning-penalty-overs" onKeyPress={event => isNumberKey(event)} name="first_inning_penalty_overs" className="text" />
                          </div>
                        </div>
                      </div>

                      <div className='form-section-col-two'>
                        <h3>
                          Score : <div style={{ display: 'inline-block' }} id="second-inning-team">--</div>
                        </h3>
                        <div className='form-section-field-one'>Run Scored: </div>
                        <div className='form-section-field-two'>
                          <Form.Control type="text" size="3" id="second-inning-runs" onKeyPress={event => isNumberKey(event)} name="first_inning_runs" className="text" />
                        </div>
                        <div className='form-section-field-one'>Wickets: </div>
                        <div className='form-section-field-two'>
                          <Form.Control type="text" size="3" id="second-inning-wickets" onKeyPress={event => isNumberKey(event)} name="first_inning_wickets" className="text" />
                        </div>
                        <div className='form-section-field-one'>Overs: </div>
                        <div className='form-section-field-two'>
                          <Form.Control type="text" size="3" id="second-inning-overs" onKeyPress={event => isfloatKey(event)} name="first_inning_overs" className="text" />
                        </div>
                        <div className='form-section-field-one'>Penalty Enf. </div>
                        <div className='form-section-field-two'>
                          <Form.Check type="checkbox" id="second-inning-penalty-enf" style={{ opacity: 0 }} name="second_inning_penalty_enf" viewdiv="second-inning-penaltydiv" className="penalitychk" label={<img src="images/info-icon.png" id="penalty_info_img" className="penalty_info" />} />
                        </div>
                        <div id="second-inning-penaltydiv" style={{ display: 'none', paddingTop: '3px' }}>
                          <div className='form-section-field-one'>Penalty Overs: </div>
                          <div className='form-section-field-two'>
                            <Form.Control type="text" size="2" id="second-inning-penalty-overs" onKeyPress={event => isNumberKey(event)} name="second_inning_penalty_overs" className="text" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='form-section-col-two'>
                      <div className="form-section-field-one">Man of the Match: </div>
                      <div className="form-section-field-two">
                        <Form.Select id='drpMom' txt='Man Of The Match'></Form.Select>
                      </div>
                    </div>
                    <div className='form-section-one-col'>
                      <div className="form-section-field-one">Highlights: </div>
                      <div className="form-section-field-two">
                        <Form.Control as="textarea" rows="4" cols="35" name="highlights" id='txtHighlights' />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sub-section form-buttons briefscore-form-buttons">
                  <Button type="submit" id="btnBPublish">Publish Brief Score</Button>&nbsp;
                  <Button type="submit" id="btnBSave" onClick={handleSaveButtonClick}>Save</Button>
                  <span id="remtext">Please save and publish the brief score before you proceed.</span>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      {/* include footer */}
    </div>
  );
};

export default BriefScore;
